import { render, staticRenderFns } from "./EditPartDesign.vue?vue&type=template&id=1588bff8&scoped=true&"
import script from "./EditPartDesign.vue?vue&type=script&lang=js&"
export * from "./EditPartDesign.vue?vue&type=script&lang=js&"
import style0 from "./EditPartDesign.vue?vue&type=style&index=0&id=1588bff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1588bff8",
  null
  
)

export default component.exports